export default __webpack_public_path__ + "static/media/EquitasLogo.b7878888.png";